import React, {Component, PropTypes} from 'react';
import Portal from 'react-portal';
import classNames from 'classnames';
import Translator from 'bazinga-translator';

import UploadHandler from './helpers/UploadHandler';
import CropHandler from './helpers/CropHandler';

import UploadView from './components/MediaUploaderSmall/UploadView';
import UploadedView from './components/MediaUploaderSmall/UploadedView';
import UploadMask from './components/MediaUploaderSmall/UploadMask';
import CropPopup from './components/CropPopup';
import Options from './components/Options';

export default class MediaUploaderSmall extends Component {
    static propTypes = {
        type: PropTypes.oneOf(['dashboard', 'app']),
        path: PropTypes.string,
        cropPath: PropTypes.string,
        reference: PropTypes.string,
        filter: PropTypes.string,
        userId: PropTypes.number,
        activeElement: PropTypes.bool,
        onActiveChange: PropTypes.func
    };

    static defaultProps = {
        type: "dashboard",
        activeElement: false
    };

    constructor(props) {
        super(props);
        this.state = {
            path: props.path,
            reference: props.reference,
            filter: props.filter,
            cropping: false,
            cropValues: undefined,
            cropPath: props.cropPath,
            uploading: false,
            percent: 0,
            text: ''
        };
        this.UploadHandler = {};
        this.CropHandler = {}
    }

    componentDidMount() {
        console.log('mounitng');
        const {filter, userId, reference, path} = this.props;
        this.setState({
            ...this.state,
            text: ::this.getProperTitle()
        });
        this.UploadHandler = new UploadHandler(filter, reference, path, null, userId, null);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.reference !== this.props.reference) {
            const {filter, reference, path} = nextProps;
            this.UploadHandler.update(filter, reference, path)
        }

    }

    getProperTitle() {
        switch (this.props.filter) {
            case ("user_logo_color"):
                return Translator.trans('media_uploader.color_ver', [], 'app');
            case ("user_logo_black"):
                return Translator.trans('media_uploader.black_ver', [], 'app');
            case ("user_logo_white"):
                return Translator.trans('media_uploader.white_ver', [], 'app');
        }
    }

    handleFileChange(formImage) {
        this.setState({
            ...this.state,
            uploading: true,
        });
        this.UploadHandler.setNewImageToSend(formImage);
        this.UploadHandler.postImage(::this.handleProgress, ::this.changeUploadState, ::this.handleUploadError);
    }

    handleProgress(data) {
        const {percent} = data;
        this.setState({
            ...this.state,
            percent,
        })
    }

    changeUploadState(values) {

        this.props.onActiveChange({
            path: `/${values.previews[this.props.filter].path}`,
            cropPath: `/${values.previews['widden_crop'].path}?${Date.now()}`,
            reference: values.ref,
            filter: this.state.filter
        });

        this.setState({
            ...this.state,
            path: `/${values.previews[this.props.filter].path}`,
            cropPath: `/${values.previews['widden_crop'].path}?${Date.now()}`,
            reference: values.ref,
            uploading: false,
            percent: 0,
        });
    }

    handleUploadError() {
        this.setState({
            ...this.state,
            uploading: false,
            percent: 0,
        })
    }

    renderProperView() {
        const {path} = this.state;
        if (path === null) {
            return (
            <UploadView onFileChange={::this.handleFileChange} text={this.state.text}/>
            )
        } else {
            return (
            <UploadedView path={this.state.path }
                          text={this.state.text}
                          type={this.props.type}
                          activeElement={this.props.activeElement}
                          onActiveChange={() => this.props.onActiveChange({
                              path: this.state.path,
                              reference: this.state.reference,
                              cropPath: this.state.cropPath,
                                filter: this.state.filter
                              }
                          )}
            />
            )
        }
    }

    renderOptionsMask() {
        if (this.state.path !== null) {
            return (
            <div className="MU_logotype--mask">
                <Options handleDelete={::this.handleDelete}
                         onFileChange={::this.handleFileChange}
                         handleCrop={::this.handleCropOpen}
                />
            </div >
            )
        }
        return null;
    }

    handleDelete() {
        this.UploadHandler.deleteImage(::this.handleResetImageData)
    }

    handleResetImageData() {
        if (this.props.activeElement) {
            this.props.onActiveChange({
                path: null,
                reference: null,
                cropPath: null,
                filter: this.state.filter
            });
        }

        this.setState({
            ...this.state,
            path: null,
            reference: null,
            cropPath: null,
        })
    }

    handleCropCancel() {
        this.setState({
            ...this.state,
            cropping: false,
        })
    }

    handleCropOpen() {
        this.setState({
            ...this.state,
            cropping: true,
        })
    }

    handleCrop(values) {

        if (this.props.activeElement) {
            this.props.onActiveChange({
                path: `/${values.previews[this.props.filter].path}`,
                reference: values.ref,
                cropPath: this.state.cropPath,
                filter: this.state.filter
            })
        }

        this.setState({
            ...this.state,
            path: `/${values.previews[this.props.filter].path}`,
            reference: values.ref,
            cropping: false,
        })
    }

    renderCropPopup() {
        if (this.state.cropping) {
            const {cropPath, cropValues, filter, reference} = this.state;
            return (
            <Portal isOpened={this.state.cropping}>
                <CropPopup src={cropPath}
                           cropValues={cropValues}
                           filter={filter}
                           reference={reference}
                           onChange={::this.handleCrop}
                           onCancel={::this.handleCropCancel}
                           onCrop={(data)=>this.handleCrop(data)}
                />
            </Portal>
            )
        }
    }

    renderUploadMask() {
        if (this.state.uploading) return (
        <UploadMask path={this.state.path} reference={this.state.reference} percent={this.state.percent}/>
        )
    }

    render() {
        const MUStyles = classNames({
            "MU_logotype": true,
            "MU_logotype--app": this.props.type === 'app',
            "MU_logotype--empty": this.props.type === 'app' && this.state.path === null,
            "black": this.state.path !== null && this.state.filter === "user_logo_white"
        });
        return (
        <div className={MUStyles}>
            {this.renderCropPopup()}
            {this.renderOptionsMask()}
            {this.renderProperView()}
            {this.renderUploadMask()}
        </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/_app/react-components/MediaUploader/MediaUploaderSmall.jsx